import { render, staticRenderFns } from "./aParityRankingGraph.vue?vue&type=template&id=652c48cd"
import script from "./aParityRankingGraph.vue?vue&type=script&lang=js"
export * from "./aParityRankingGraph.vue?vue&type=script&lang=js"
import style0 from "./aParityRankingGraph.vue?vue&type=style&index=0&id=652c48cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VTooltip})
